module.exports = __webpack_public_path__ + "static/img/home-img-3.2ca4452.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-img-3.jpg
// module id = GdG7
// module chunks = 0